module.exports = __webpack_public_path__ + "static/img/template-badge-69.e17b877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/template-badge-69.png
// module id = 584
// module chunks = 4